import { FahrradWert } from '@ps20/bff-models';
import { IAppState } from '../../../store/appState';
import {
  isFahrradBaustein,
  ZUSATZOPTION_FAHRRAD_ID,
  ZUSATZOPTION_FAHRRAD_KASKO_ID,
} from '../../../store/model/fahradwertForLinie.model';
import { EntschaedigungsgrenzeRadForLinie, isEntschaedigungsgrenzeValid } from '../../../store/model/entschaedigungsgrenzeRad.model';
import { selectSelectedProduktlinie } from './produkt.selector';
import { selectVhvRelevantVorbelegungdaten } from './transient-state.selector';

export const selectFahrradWertOfSelectedLinie = (state: IAppState): FahrradWert => {
  const selectedProduktlinie = selectSelectedProduktlinie(state);

  if (!selectedProduktlinie) {
    return null;
  }
  const zusatzoptionen = selectedProduktlinie.zusatzoptionen;
  const presettedSumValue = zusatzoptionen?.find(
    zo => zo.id === ZUSATZOPTION_FAHRRAD_ID || zo.id === ZUSATZOPTION_FAHRRAD_KASKO_ID,
  )?.eigenschaft;
  if (presettedSumValue) {
    return FahrradWert[presettedSumValue as keyof typeof FahrradWert];
  }

  const versicherungssummeFahrrad = state.versicherungssummeFahrrad.find(
    summeFahrrad => summeFahrrad.produktlinie === selectedProduktlinie.produktName,
  );

  if (versicherungssummeFahrrad) {
    return versicherungssummeFahrrad.summe;
  }
  throw new Error(
    `Keine versicherungssummeFahrrad für Linie ${selectedProduktlinie.produktName} gefunden!`,
  );
};

export const selectVersSumme = (state: IAppState): number =>
  Number(state.vertragsoptionen.versicherungssumme);

export const selectEntschaedigungsgrenzeRadOfSelectedLinie = (
  state: IAppState,
): EntschaedigungsgrenzeRadForLinie | null => {
  const selectedProduktlinie = selectSelectedProduktlinie(state);
  if (!selectedProduktlinie) {
    return null;
  }
  return (
    state.entschaedigungsgrenzeRad?.find(
      linie => linie.produktlinie === selectedProduktlinie.produktName,
    ) ?? null
  );
};

export const selectIsFahrradSelectedWithInvalidEntschaedigungsgrenze = (
  state: IAppState,
): boolean => {
  const selectedProduktlinie = selectSelectedProduktlinie(state);
  if (!selectedProduktlinie) {
    return false;
  }
  const fahrradSelected = selectedProduktlinie.zusatzoptionen?.some(
    zo =>
      (zo.id === ZUSATZOPTION_FAHRRAD_ID || zo.id === ZUSATZOPTION_FAHRRAD_KASKO_ID) &&
      zo.isSelected,
  );
  if (!fahrradSelected) {
    return false;
  }
  const grenze = state.entschaedigungsgrenzeRad?.find(
    linie => linie.produktlinie === selectedProduktlinie.produktName,
  );
  if (!grenze) {
    return false;
  }
  return !isEntschaedigungsgrenzeValid(grenze.betrag, grenze.minInput, grenze.maxInput);
};

export const selectIsEntschaedigungsgrenzeInvalidDueToUnchangedVorbelegung = (
  state: IAppState,
): boolean => {
  const grenze = selectEntschaedigungsgrenzeRadOfSelectedLinie(state);
  if (!grenze || isEntschaedigungsgrenzeValid(grenze.betrag, grenze.minInput, grenze.maxInput)) {
    return false;
  }
  const fahrradBaustein = selectVhvRelevantVorbelegungdaten(state)?.vorvertragBausteinList?.find(
    isFahrradBaustein,
  );
  return fahrradBaustein?.betrag != null && fahrradBaustein.betrag === grenze.betrag;
};
